import React, { useMemo, createContext, PropsWithChildren, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useThunderAuth } from '@wsb/gasket-thunder-auth-react';
import userAnalytics from '@godaddy/user-analytics-js';
import { getAnalyticsConfig } from '../redux/selectors/getAnalyticsConfig';
import { EVENT_MAP } from '../constants/analyticsEvents';
import { setThunkExtras } from '../redux/thunks/setThunkExtras';
import { useDispatch } from '../hooks/useDispatch';

export const AnalyticsTrackerContext = createContext(null);

export const AnalyticsTrackerProvider = ({ children }: PropsWithChildren) => {
  const analyticsConfig = useSelector(getAnalyticsConfig);
  const isAgent = useThunderAuth().isAgent();
  const dispatch = useDispatch();

  const trackerValue = useMemo(() => {
    const tracker = userAnalytics(analyticsConfig);
    tracker.updateEventMap(EVENT_MAP);

    tracker.addSuperProperties({
      isAgent
    });

    return tracker;
  }, [analyticsConfig, isAgent]);

  useEffect(() => {
    dispatch(setThunkExtras({ clientTracker: trackerValue }));
  }, [dispatch, trackerValue]);

  return (
    <AnalyticsTrackerContext.Provider value={trackerValue}>
      {children}
    </AnalyticsTrackerContext.Provider>
  );
};
